import { useState, useCallback } from 'react';

export interface BookContextItem {
  id: string;  // UUID from backend (was incorrectly typed as number)
  title: string;
  category: string;
}

export const useBookContext = () => {
  const [selectedBooks, setSelectedBooks] = useState<BookContextItem[]>([]);

  const addBook = useCallback((book: BookContextItem) => {
    setSelectedBooks(prev => {
      // Don't add duplicates
      if (prev.some(b => b.id === book.id)) {
        return prev;
      }
      return [...prev, book];
    });
  }, []);

  const removeBook = useCallback((bookId: string) => {
    setSelectedBooks(prev => prev.filter(b => b.id !== bookId));
  }, []);

  const clearBooks = useCallback(() => {
    setSelectedBooks([]);
  }, []);

  const setBooks = useCallback((books: BookContextItem[]) => {
    setSelectedBooks(books);
  }, []);

  const getBookIds = useCallback(() => {
    return selectedBooks.map(b => b.id);
  }, [selectedBooks]);

  return {
    selectedBooks,
    addBook,
    removeBook,
    clearBooks,
    setBooks,
    getBookIds
  };
};
